import React from 'react';
import SearchIcon from "@mui/icons-material/Search";
import {
  Avatar,
  Button, Chip,
  Dialog, DialogActions,
  DialogContent, DialogContentText,
  DialogTitle, Divider,
  IconButton,
  Tooltip, Typography
} from "@mui/material";
import {withStyles} from "@mui/styles";
import FileDownload from "js-file-download";
import {download} from "../../utils/api";
import {formatTime} from "../../utils/timeHelper";

const styles = () => ({
  paper: {
    maxWidth: '90%',
    margin: 'auto',
    marginTop: '2rem',
    overflow: 'hidden',
  },
  toolbar: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  block: {
    display: 'block',
  },
  contentWrapper: {
    margin: '16px 16px',
  },
});

function ReceiptDetailViewDialog(props) {
  const { classes, receipt } = props;
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function calculateConvertedAmount(amountToConvert, rate) {
    return Math.round(((amountToConvert / rate) + Number.EPSILON) * 100) / 100;
  }

  // Converts through both the intermediate and reporting exchange rate in one step and
  // rounds once, so the result matches the backend's per-receipt conversion exactly
  // (rounding after each intermediate step compounds cent-level errors).
  function calculateReportingAmount(amountToConvert, intermediateRate, rate) {
    const rawAmount = intermediateRate > 0
      ? amountToConvert / intermediateRate / rate
      : amountToConvert / rate;
    return Math.round((rawAmount + Number.EPSILON) * 100) / 100;
  }

  return (
      <>
        <Tooltip title="Show details">
          <IconButton  onClick={handleClickOpen}>
            <SearchIcon sx={{ fontSize: 24 }} className={classes.block} color="inherit" />
          </IconButton>
        </Tooltip>
        <Dialog fullWidth={true} maxWidth={'md'} className={classes.dialog} open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
          <DialogTitle>
            <div style={{ textAlign: 'right'}}>Transaction Date: {formatTime(receipt.transactionDate)}</div>
            <div style={{ textAlign: 'right'}}>Transaction Ref: {receipt.transactionRef}</div>
            <div style={{ textAlign: 'right'}}>Transaction Ref (Partner): {receipt.transactionRefPartner}</div>
            <Divider sx={{ marginTop: 5, marginBottom: 2 }}/>
            <Typography variant="h2">{receipt.invoiceNumber}</Typography>
            <Divider sx={{ marginTop: 2, marginBottom: 2 }}/>
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1">Paid by: {receipt.organisation ? receipt.organisation.name : ''}</Typography>
            <Typography variant="body1">Payee: {receipt.payee}</Typography>
            <Typography variant="body1">Budget line: {receipt.budgetLine}</Typography>
            <Typography variant="body1">Description: {receipt.description}</Typography>
            <Divider sx={{ marginTop: 5, marginBottom: 2 }}/>
            <Typography variant="body1">Amount in original currency: {receipt.amount} {receipt.currency}</Typography>
            { receipt.intermediateExchangeRate > 0 &&
                <Typography variant="body1">Amount in functional currency: {calculateConvertedAmount(receipt.amount, receipt.intermediateExchangeRate)} ${receipt.intermediateCurrency ? receipt.intermediateCurrency.code : ''}</Typography>
            }
            <Typography variant="h4">Amount: {receipt.amount > 0 && receipt.exchangeRate > 0 ? `${calculateReportingAmount(receipt.amount, receipt.intermediateExchangeRate, receipt.exchangeRate)} €` : ''}</Typography>
            { receipt.activity &&
              <>
                <Divider sx={{ marginTop: 2, marginBottom: 2 }}/>
                <Typography variant="body1">Output activity: {receipt.activity ? receipt.activity.name : ''}</Typography>
                <Typography variant="body1">{receipt.activity ? receipt.activity.description : ''}</Typography>
              </>
            }
            <Divider sx={{ marginTop: 2, marginBottom: 2 }}/>
            { receipt.attachments && receipt.attachments.length > 0 &&
              <>
                <DialogContentText sx={{ marginTop: 2 }}>
                  The following {receipt.attachments.length > 1 ? receipt.attachments.length + ' files have' : 'file has'} been attached to this receipt:
                </DialogContentText>
                { receipt.attachments && receipt.attachments.length > 0 && receipt.attachments.map((file, idx) => (
                    <Chip key={idx} onClick={() => download(file.uuid).then((response) => {
                      FileDownload(response.data, file.filename);
                    })} sx={{margin: 1}} avatar={<Avatar>{file.filename.slice(file.filename.lastIndexOf('.') + 1)}</Avatar>} label={file.filename} />
                ))}
              </>
            }
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary" size="small">
              Close
            </Button>
            {/*<Button onClick={handleConfirm} color="primary" size="small">*/}
            {/*  Confirm*/}
            {/*</Button>*/}
          </DialogActions>
        </Dialog>
      </>
  );
}

export default withStyles(styles)(ReceiptDetailViewDialog)